import { render } from "./NcModal.vue?vue&type=template&id=42e7c8aa&scoped=true"
import script from "./NcModal.vue?vue&type=script&lang=js"
export * from "./NcModal.vue?vue&type=script&lang=js"

import "./NcModal.vue?vue&type=style&index=0&id=42e7c8aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e7c8aa"]])

export default __exports__